import { useState, useMemo } from "react";
import { useIntl, FormattedMessage } from "react-intl";

import { getPrefills } from "api";
import Button from "components/atoms/Button/Button";
import DataTable from "components/organisms/DataTable/DataTable";
import useTableRequest from "hooks/useTableRequest";
import LocationFilter from "components/molecules/LocationFilter/LocationFilter";
import getPrefillsColumns from "./prefillsColumns";
import PrefillsDialog from "./PrefillsDialog";

function Prefills() {
  const intl = useIntl();

  const [location, setLocation] = useState<string>("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const columns = useMemo(() => getPrefillsColumns(intl), []);

  const { instance, fetching, totalData, refetch } = useTableRequest(getPrefills, columns, {
    params: {
      location,
    },
    deps: [location],
  });

  const handleFilterSelect = (selectedLocation: string) => {
    setLocation(selectedLocation);
  };

  return (
    <div>
      <PrefillsDialog
        data={selectedRow}
        show={showDialog}
        fetchData={refetch}
        close={() => {
          setSelectedRow(null);
          setShowDialog(false);
        }}
        selectedPrefill={selectedRow}
      />
      <DataTable
        tableInstance={instance}
        totalData={totalData}
        isLoading={fetching}
        draggable={false}
        headerRight={
          <div className="mt-3 d-flex">
            <div className="mr-3">
              <LocationFilter onChange={handleFilterSelect} />
            </div>
            <Button onClick={() => setShowDialog(true)}>
              <FormattedMessage id="settings.prefills.addPrefill" defaultMessage="Add Prefill" />
            </Button>
          </div>
        }
        onRowClick={(row) => {
          setSelectedRow(row.original);
          setShowDialog(true);
        }}
      />
    </div>
  );
}

export default Prefills;
